import { useCallback, useEffect, useState } from "react";
import { useQuickMessagesApi } from "../api/quickMessagesApi";

export function useQuickMessages() {
  const api = useQuickMessagesApi();
  const [quickMessages, setQuickMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchQuickMessages = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setQuickMessages(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addQuickMessage = async (data) => {
    const created = await api.create(data);
    setQuickMessages((prev) => [...prev, created]);
    return created;
  };

  const updateQuickMessage = async (id, data) => {
    const updated = await api.update(id, data);
    setQuickMessages((prev) =>
      prev.map((msg) => (msg.id === id ? { ...msg, ...updated } : msg)),
    );
    return updated;
  };

  const deleteQuickMessage = async (id) => {
    await api.remove(id);
    setQuickMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  useEffect(() => {
    fetchQuickMessages();
  }, [fetchQuickMessages]);

  return {
    quickMessages,
    loading,
    error,
    fetchQuickMessages,
    addQuickMessage,
    updateQuickMessage,
    deleteQuickMessage,
  };
}
